const redirectToOAuth = OAUTH_URL => {
  window.location.replace(OAUTH_URL);
};

export default {
  redirectToOAuth,
};
